import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Gallery from '@/components/Gallery'
// import Welcome from '@/components/Welcome'
import Welcome from '@/components/BetaWelcome'
import NewAlbum from '@/components/NewAlbum'
import AlbumDetails from '@/components/AlbumDetails'
import FirebaseController from "../controllers/FirebaseController";

Vue.use(Router)

let router = new Router({
	routes: [
		{
			path: '*',
			redirect: '/welcome'
		},
		{
			path: '/',
			redirect: '/welcome'
		},
		{
			path: '/welcome',
			component: Welcome
		},
		{
			path: '/gallery',
			component: Gallery,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/album/new',
			component: NewAlbum,
			meta: {
				requiresAuth: true
			}
		},
		{
			path: '/album/:id',
			component: AlbumDetails,
			meta: {
				requiresAuth: true
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	let currentUser = FirebaseController.user()
	let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

	if (requiresAuth && !currentUser) next('welcome')
	else if (!requiresAuth && currentUser) next('gallery')
	else next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js